/**
 * Lowercases only the first character of a supplied string.
 *
 * Postconditions: Falsy input returns undefined; the remaining substring is unchanged. This is
 * a leading-character conversion, not a word-splitting or acronym-normalization algorithm.
 */
const convertPascalToCamel = (camelCaseStr: string | undefined) => {
    if (!camelCaseStr) {
        return undefined;
    }

    return camelCaseStr.charAt(0).toLowerCase() + camelCaseStr.slice(1);
};

export default convertPascalToCamel;
